<script setup>

import KdContainer from "./kdContainer.vue";


</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="400px">


      <el-form-item label="海外市场及KD工厂车辆是否涉及该问题" prop="hasInventoryVehicle">
        <el-radio-group :disabled="marketVehicles && marketVehicles.hasInventoryVehicle != undefined" v-model="form.hasInventoryVehicle">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-show="form.hasInventoryVehicle == '1'">
        <el-form-item label="海外市场及KD工厂车辆处置方案" prop="inventoryVehicleDisposalSolution">
          <el-input :disabled="marketVehicles && marketVehicles.inventoryVehicleDisposalSolution != undefined" placeholder="请输入海外市场及KD工厂车辆处置方案" v-model="form.inventoryVehicleDisposalSolution" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <file-upload-list
            v-if="marketVehicles && marketVehicles.inventoryVehicleDisposalSolutionFiles != undefined"
            ref="fileUploadList"
            :fileList="form.inventoryVehicleDisposalSolutionFiles"
          ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.inventoryVehicleDisposalSolutionFiles"
              :httpRequest="imAction"/>
        </el-form-item>
      </div>

      <el-form-item label="海外KD工厂、运输途中、鑫源及供应商处物料是否涉及该问题" prop="hasMarketVehicle">
        <el-radio-group :disabled="marketVehicles && marketVehicles.hasMarketVehicle != undefined" v-model="form.hasMarketVehicle">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-show="form.hasMarketVehicle == '1'">
        <el-form-item label="海外KD工厂、运输途中、鑫源及供应商处物料处置方案" prop="marketVehicleDisposalSolution">
          <el-input :disabled="marketVehicles && marketVehicles.marketVehicleDisposalSolution != undefined" placeholder="请输入海外KD工厂、运输途中、鑫源及供应商处物料处置方案" v-model="form.marketVehicleDisposalSolution" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <div>
            <file-upload-list
              v-if="marketVehicles && marketVehicles.marketVehicleDisposalSolutionFiles != undefined"
              ref="fileUploadList"
              :fileList="form.marketVehicleDisposalSolutionFiles"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.marketVehicleDisposalSolutionFiles"
              :httpRequest="imAction"/>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="是否接受索赔" prop="acceptAClaim">
        <el-radio-group v-model="form.acceptAClaim" :disabled="this.taskDefKey != 'Activity_06py48i' && this.taskDefKey != 'Activity_1swuo28'">
          <el-radio :label="0">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="auditForm">
        <el-form-item>
          <el-button class="lang-but" type="primary" @click="submitDataBtClick">确定</el-button>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item>
          <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
          <el-button v-if="this.taskDefKey != 'Activity_06py48i'" class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
        </el-form-item>
      </div>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAudit} from "../../api/feedback";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 14.3-QE输出市场KD工厂物料及库存物料处置方案
 * 15.3-质量改善部部长审核市场KD工厂及库存物料处置方案
 * 16.3-质量经理审核KD工厂及库存物料处置方案
 * 17.3-售后服务部部长审核KD工厂及库存物料处置方案
 */
export default {
  name: "qeVehicleDisposalPlanForTheOutputMarketAudit",
  components: { KdAuditPassDialog },
    props: {
      taskId:String,
      questionId:String,
      taskDefKey:String,
      marketVehicles: Object,
      auditForm:{
        type: Boolean,
        default: false
      },
      receivedForm:{
        permanentSolution:{
          type: String,
          default: ""
        },
        hasMarketVehicle:{
          type:Number,
          default: undefined
        },
        marketVehicleDisposalSolution:{
          type: String,
          default: ""
        },

        marketVehicleDisposalSolutionFiles:{
          type: Array,
          default: undefined
        },
        hasInventoryVehicle:{
          type:Number,
          default: undefined
        },
        inventoryVehicleDisposalSolution:{
          type: String,
          default: ""
        },
        inventoryVehicleDisposalSolutionFiles:{
          type: Array,
          default: undefined
        },
        hasQualityProblem:{
          type:Number,
          default: undefined
        },
        reasonAnalystMaterial:{
          type: String,
          default: ""
        },
        reasonAnalyst: {
          type:String,
          default: ""
        },
        requestCompletionProcess:{
          type:Number,
          default: undefined
        },
        practicalBreakpointTime:{
          type:String,
          default: ""
        },
        pdiCheckContent:{
          type: String,
          default: ""
        },
        pdiCheckResult:{
          type: String,
          default: ""
        },
        pdiCheckResultFiles:{
          type: Array,
          default: undefined
        },
        files:Array
      }
    },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction:"/manage/staff/upload?fileType=auditResource",
      assignUser:"",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        inventoryVehicleDisposalSolutionFiles:[],
        marketVehicleDisposalSolutionFiles:[],
        acceptAClaim: 0,
        hasInventoryVehicle: 1,
        hasMarketVehicle: 1,
        inventoryVehicleDisposalSolution: "",
        marketVehicleDisposalSolution: "",
        rejectReason:"",
        auditText: "",
      },
      rules: {
        hasMarketVehicle: [
          { required: true, message: "是否存在KD工厂物料不能为空", trigger: ["blur", "change"] }
        ],
        marketVehicleDisposalSolution:  [
          {
            required: true, message: "KD工厂物料处置方案不能为空", trigger: ["blur", "change"]
          }
        ],
        hasInventoryVehicle:  [
          {
            required: true, message: "是否存在库存物料不能为空", trigger: ["blur", "change"] }
        ],
        inventoryVehicleDisposalSolution:  [
          {
            required: true, message: "库存物料处置方案不能为空", trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
    "form.hasMarketVehicle"(newVal) {
      this.form.marketVehicleDisposalSolution = this.marketVehicles.marketVehicleDisposalSolution??'';
      if (newVal == 0) {
        this.$set(this.rules, "marketVehicleDisposalSolution", []);
        this.$refs.formRef.clearValidate("marketVehicleDisposalSolution");
      } else {
        this.$set(this.rules, "marketVehicleDisposalSolution", [{  required: true, message: "KD工厂物料处置方案不能为空", trigger: ["blur", "change"] }]);
      }
    },
    "form.hasInventoryVehicle"(newVal) {
      this.form.inventoryVehicleDisposalSolution = this.marketVehicles.inventoryVehicleDisposalSolution??'';
      if (newVal == 0) {
        this.$set(this.rules, "inventoryVehicleDisposalSolution", []);
        this.$refs.formRef.clearValidate("inventoryVehicleDisposalSolution");
      } else {
        this.$set(this.rules, "inventoryVehicleDisposalSolution", [{ required: true, message: "库存物料处置方案不能为空", trigger: ["blur", "change"] }]);

      }
    }
  },
  methods: {
    submitDataBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.$confirm('确认提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = {
            taskId: this.taskId,
            approval: true
          }
          requestSubmitAuditKD(formData).then(res => {
            if (res.status == "0") {
              this.$DonMessage.success('提交成功!');
              this.backRouterPath();
            }
          })
        })
      })

    },
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })

    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        marketVehicles: this.form,
        variables: {
          approval: true,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    },
  },
  mounted() {
    if(this.marketVehicles){
      this.form.hasMarketVehicle = (this.marketVehicles.hasMarketVehicle)?Number(this.marketVehicles.hasMarketVehicle):0;
      this.form.marketVehicleDisposalSolution = this.marketVehicles.marketVehicleDisposalSolution??'';
      this.form.marketVehicleDisposalSolutionFiles = this.marketVehicles.marketVehicleDisposalSolutionFiles??[];
      this.form.hasInventoryVehicle = (this.marketVehicles.hasInventoryVehicle)?Number(this.marketVehicles.hasInventoryVehicle):0;
      this.form.inventoryVehicleDisposalSolution = this.marketVehicles.inventoryVehicleDisposalSolution??'';
      this.form.inventoryVehicleDisposalSolutionFiles = this.marketVehicles.inventoryVehicleDisposalSolutionFiles??[];
      this.form.acceptAClaim = (this.marketVehicles.acceptAClaim)?Number(this.marketVehicles.acceptAClaim):0;
    }
  }
}
</script>
